import React, { useState, useEffect } from "react";
import "../Pages/CSS/Donation.css";
import "bootstrap/dist/css/bootstrap.min.css";
import PageTransition from "../Components/PageTransition";
import AnimatedHero from "../Components/AnimatedHero";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase-config"; 
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import logo from "../Images/logodarvik.png";
const loadRazorpayScript = (src) =>
  new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = resolve;
    document.body.appendChild(script);
  });

export default function Donation() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    address: "",
    pincode: "",
    pan: "",
    taxExempt: false,
    updates: false,
    declaration: false,
    amount: 100
  });

  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success"); // "success" or "error"
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const showToastMessage = (message, type = "success", duration = 4000) => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), duration);
  };

  const isFormValid = 
    form.name.trim() &&
    form.phone.trim() &&
    form.email.trim() &&
    form.city.trim() &&
    form.address.trim() &&
    form.pincode.trim() &&
    form.declaration;

  const handleDonate = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      showToastMessage("Please fill all required fields and accept the declaration.", "error");
      return;
    }

    setLoading(true);
    await loadRazorpayScript("https://checkout.razorpay.com/v1/checkout.js");

    const options = {
      key: "rzp_live_RGIVtgKmvs1ZXw",
      amount: Number(form.amount) * 100,
      currency: "INR",
      name: "Darvik Foundation",
      description: "One Time Donation",
      image: "/logodarvik.png",
      handler: async function (response) {
        try {
          await addDoc(collection(db, "donations"), {
            name: String(form.name).trim(),
            phone: String(form.phone).trim(),
            email: String(form.email).trim(),
            city: String(form.city).trim(),
            address: String(form.address).trim(),
            pincode: String(form.pincode).trim(),
            pan: String(form.pan || ""),
            amount: String(form.amount),
            declaration: !!form.declaration,
            taxExempt: !!form.taxExempt,
            updates: !!form.updates,
            razorpay_payment_id: String(response.razorpay_payment_id || ""),
            razorpay_order_id: String(response.razorpay_order_id || ""),
            razorpay_signature: String(response.razorpay_signature || ""),
            created: serverTimestamp()
          });

          // Pass toast message to thank-you page
          navigate(`/thank-you?payment_id=${response.razorpay_payment_id}`, {
            state: {
              toastMessage: `Thank you for your donation! Payment ID: ${response.razorpay_payment_id}`,
              toastType: "success"
            }
          });

        } catch (err) {
          console.error("Firestore save error:", err.message);
          showToastMessage("Error while saving donation: " + err.message, "error");
        }
        setLoading(false);
      },
      prefill: {
        name: form.name,
        email: form.email,
        contact: form.phone,
      },
      notes: {
        city: form.city,
        address: form.address,
        pincode: form.pincode,
        pan: form.pan,
        taxExempt: form.taxExempt ? "Yes" : "No",
        updates: form.updates ? "Yes" : "No"
      },
      theme: {
        color: "var(--secondary)",
      },
      modal: {
        ondismiss: function() {
          setLoading(false);
        }
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <PageTransition className="donation-page bg-light">
      <AnimatedHero
        title="Support Our Cause"
        subtitle="Your generous donation helps us continue our mission to make a positive impact in our community"
        className="gallery-hero"
        overlayColor="rgba(243,38,140,0.15)"
      />

      {/* Toast Notification */}
      <div className={`custom-toast ${toastType} ${showToast ? "show" : ""}`}>
        {toastMessage}
      </div>
      
      <section className="donation-section">
  <div className="container py-5 text-center">
    <div style={{ display: 'flex', alignItems: 'center' }}>
  
  {/* Logo on Left */}
  <img
    src={logo}
    alt="Darvik Logo"
    style={{ height: '80px', width: 'auto', marginRight: '1rem' }}
  />

  {/* Name Section on Right */}
  <div style={{ textAlign: 'left' }}>
    <h1 style={{ fontWeight: 'bold', textTransform: 'uppercase', margin: 0 ,fontFamily:'Plus Jakarta Sans'}}>
      Darvik
    </h1>
    <div style={{ fontSize: '1.25rem', textTransform: 'uppercase', letterSpacing: '1px'}}>
      Foundation Trust
    </div>
  </div>

</div>

    <div className="row g-4">


            {/* Left: Info & Amount */}
            <div className={`col-lg-6 ${isVisible ? 'animate-fade-in' : ''}`}>
              <div className="card donation-card h-100">
                <div className="card-header donation-card-header text-center">
                  <div className="donation-logo-container mb-3">
                    <img src="/logodarvik.png" alt="Darvik Foundation" className="donation-logo" />
                  </div>
                  <h2 className="h4 fw-bold primary mb-2">One Time Donation</h2>
                  <p className="secondary fw-semibold">YOU ARE SIGNING UP FOR A ONE TIME DONATION OF</p>
                  <div className="mb-4">
                    <label className="form-label fw-semibold primary">Donation Amount (INR)*</label>
                    <div className="input-group">
                      <span className="input-group-text secondary fw-bold">₹</span>
                      <input
                        type="number"
                        name="amount"
                        min="1"
                        className="form-control form-control-lg"
                        value={form.amount}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-center flex-wrap gap-2 mb-4">
                    {[100, 500, 1000, 2000, 5000, 10000].map((amt) => (
                      <button
                        key={amt}
                        type="button"
                        onClick={() => setForm((f) => ({ ...f, amount: amt }))}
                        className={`btn ${form.amount === amt ? "btn-accent" : "btn-secondary"}`}
                        style={{ minWidth: "90px" }}
                      >
                        ₹{amt.toLocaleString()}
                      </button>
                    ))}
                  </div>
                  <div className="alert alert-info d-flex align-items-start">
                    <div className="flex-shrink-0 me-3">
                      <i className="bi bi-info-circle-fill secondary"></i>
                    </div>
                    <div>
                      <strong>Your payment is Secure</strong><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Donor Details */}
            <div className={`col-lg-6 ${isVisible ? 'animate-fade-in animate-delay-150' : ''}`}>
              <div className="card donation-card h-100">
                <div className="card-header donation-card-header">
                  <h3 className="h4 fw-bold secondary mb-0">Personal Details</h3>
                </div>
                <div className="card-body">
                  <form onSubmit={handleDonate} autoComplete="off">
                    <div className="row g-3 mb-4">
                      {/* Full Name */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold secondary">Full Name*</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-person-fill secondary"></i></span>
                          <input type="text" name="name" className="form-control secondary-light" value={form.name} onChange={handleChange} required placeholder="Enter your full name"/>
                        </div>
                      </div>
                      {/* Phone */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold secondary">Phone No.*</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-telephone-fill secondary"></i></span>
                          <input type="tel" name="phone" className="form-control secondary-light" value={form.phone} onChange={handleChange} required placeholder="Enter your phone no"/>
                        </div>
                      </div>
                      {/* Email */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold secondary">Email Address*</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-envelope-fill secondary"></i></span>
                          <input type="email" name="email" className="form-control secondary-light" value={form.email} onChange={handleChange} required placeholder="Enter your email"/>
                        </div>
                      </div>
                      {/* City */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold secondary">City*</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-geo-alt-fill secondary"></i></span>
                          <input type="text" name="city" className="form-control secondary-light" value={form.city} onChange={handleChange} required placeholder="Enter your city"/>
                        </div>
                      </div>
                      {/* Address */}
                      <div className="col-12">
                        <label className="form-label fw-semibold secondary">Address*</label>
                        <textarea name="address" className="form-control" rows="3" value={form.address} onChange={handleChange} required placeholder="Enter your complete address"></textarea>
                      </div>
                      {/* Pincode */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold secondary">Pincode*</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-mailbox secondary"></i></span>
                          <input type="text" name="pincode" className="form-control" value={form.pincode} onChange={handleChange} required placeholder="Enter pincode"/>
                        </div>
                      </div>
                      {/* PAN */}
                      <div className="col-md-6">
                        <label className="form-label fw-semibold secondary">PAN (Optional)</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-credit-card secondary"></i></span>
                          <input type="text" name="pan" className="form-control" value={form.pan} onChange={handleChange} placeholder="Enter PAN for tax exemption"/>
                        </div>
                      </div>
                    </div>

                    {/* Checkboxes */}
                    <div className="mb-4">

                    

                      {/* Updates Checkbox */}
                      <div className="form-check mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="updates"
                          id="updates"
                          checked={form.updates}
                          onChange={handleChange}
                        />
                        <label className="form-check-label secondary" htmlFor="updates">
                          Keep me updated via Email and Phone about Darvik Foundation activities.
                        </label>
                      </div>

                      {/* Declaration + Terms Acceptance */}
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="declaration"
                          id="declaration"
                          checked={form.declaration}
                          onChange={handleChange}
                        />
                        <label className="form-check-label secondary fw-medium" htmlFor="declaration">
                          I declare that the information provided is complete and accurate, and I agree to the{" "}
                          <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                            Terms & Conditions
                          </a>,{" "}
                          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                            Privacy Policy
                          </a>, and{" "}
                          <a href="/refund-policy" target="_blank" rel="noopener noreferrer">
                            Refund & Cancellation Policy
                          </a>.
                        </label>
                      </div>

                    </div>

                    <button type="submit" className={`btn btn-lg w-100 d-flex align-items-center justify-content-center ${loading ? "btn-accent" : "btn-primary donation-btn"}`} disabled={loading}>
                      {loading ? (
                        <>
                          <div className="spinner-border spinner-border-sm me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          Processing...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-heart-fill me-2"></i>
                          Donate Now
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </PageTransition>
  );
}
